import React, { useEffect, useState } from "react";
import brands from "./brands";
import Brand from "./components/Brand";
import Input from "./components/Input";
import Box from "./components/Box";
import Open from "./components/svg/Open";

const protocol = "https://";
const clusterURL = "public.keystone-qa-eks-euw1.futureplc.engineering";
const recentCacheKey = "keystone-url-finder-recent";

interface RecentItem {
  branch: string;
  path: string;
}

function App() {
  const [branch, setBranch] = useState("");
  const [path, setPath] = useState("");
  const [recent, setRecent] = useState<RecentItem[]>([]);

  const maxRecentLength = 20;

  useEffect(() => {
    setRecent(JSON.parse(localStorage.getItem(recentCacheKey) || "[]"));

    const params = new URLSearchParams(window.location.search);

    params.forEach((value, key) => {
      if (key === "branch") {
        setBranch(value);
      }

      if (key === "path") {
        setPath(value);
      }
    });
  }, []);

  const addToRecent = (item: RecentItem) => {
    if (
      !branch.length ||
      recent.find((r) => r.branch === item.branch && r.path === item.path)
    ) {
      return;
    }

    const nextRecent = [{ branch, path }, ...recent];

    if (nextRecent.length >= maxRecentLength) {
      nextRecent.splice(maxRecentLength);
    }

    setRecent(nextRecent);

    localStorage.setItem(recentCacheKey, JSON.stringify(nextRecent));
  };

  return (
    <div className="bg-slate-200 w-full min-h-screen">
      <div className="w-[80%] mx-auto pt-8 flex">
        <div className="w-[500px] mr-6">
          <Box title="Keystone URL Finder">
            <Input
              label="Branch Name:"
              placeholder="branch"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
            />
            <Input
              label="Path:"
              placeholder="path"
              value={path}
              onChange={(e) => setPath(e.target.value)}
            />
          </Box>

          <Box className="mt-4" padded={false}>
            <a
              href={`https://argocd.futuretech.tools/applications/?showFavorites=false&search=keystone${
                branch ? "-" + branch : ""
              }`}
              target="_BLANK"
              rel="noreferrer"
              className="flex justify-between items-center hover:bg-slate-400 transition-all p-4"
            >
              Argo
              <Open />
            </a>
          </Box>

          <Box className="mt-4" title="Recents">
            {recent.map((item, idx) => (
              <button
                key={idx}
                className="inline-block p-2 mr-2 mb-2 rounded-sm bg-slate-200 text-xs text-left"
                onClick={(e) => {
                  setBranch(item.branch);
                  setPath(item.path);
                }}
              >
                <p>
                  <span className="font-semibold">{item.branch}</span>
                  {!!item.path.length && `${item.path}`}
                </p>
              </button>
            ))}
          </Box>
        </div>

        <div className="w-full">
          <ul>
            {brands.map((brand) => (
              <li key={brand.id}>
                <Brand
                  id={brand.id}
                  name={brand.name}
                  url={
                    branch.length
                      ? `${protocol}${brand.url}.${branch}.${clusterURL}`
                      : `${protocol}${brand.url}`
                  }
                  path={path}
                  onClick={() => addToRecent({ branch, path })}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default App;
